// @ts-nocheck
import { httpClient } from '../../../core/network';

class MessageService {
  static fetchServiceMessages() {
    const apiUrl = '/servicemessages';
    return httpClient.get(apiUrl);
  }

  static fetchPlatforms() {
    const apiUrl = '/servicemessages/platforms';
    return httpClient.get(apiUrl);
  }

  static createServiceMessage(messageData) {
    const apiUrl = '/servicemessages';
    return httpClient.post(apiUrl, messageData);
  }

  static updateServiceMessage(messageData) {
    const apiUrl = `/servicemessages/${messageData.id}`;
    return httpClient.put(apiUrl, messageData);
  }
}

export default MessageService;
